/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menunoplaces2Inputs */

const en_menunoplaces2 = /** @type {(inputs: Menunoplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a place first. Lunch menus and menus always belong to a place.`)
};

const de_menunoplaces2 = /** @type {(inputs: Menunoplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leg zuerst einen Ort an. Mittagsmenü und Speisekarte gehören immer zu einem Ort.`)
};

/**
* | output |
* | --- |
* | "Create a place first. Lunch menus and menus always belong to a place." |
*
* @param {Menunoplaces2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menunoplaces2 = /** @type {((inputs?: Menunoplaces2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menunoplaces2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menunoplaces2(inputs)
	return de_menunoplaces2(inputs)
});
export { menunoplaces2 as "menuNoPlaces" }